import React from "react";
import { TextField } from "@mui/material";

const IntegerEditCell = ({ value, onValueChange }) => {
  const [localValue, setLocalValue] = React.useState(
    value === null || value === undefined ? "" : Number(value)
  );

  // Sync with external value (e.g. after reload)
  React.useEffect(() => {
    setLocalValue(
      value === null || value === undefined ? "" : Number(value)
    );
  }, [value]);


  const handleChange = (event) => {
    // Allow only digits and one decimal point
     let val = event.target.value;
    val = val.replace(/[^0-9.]/g, "");    // remove invalid chars
    val = val.replace(/(\..*)\./g, "$1"); // prevent multiple dots
    setLocalValue(val);
  // If val is valid number (not just ".")
    if (val !== "" && val !== ".") {
      const num = Number(val);
      if (!isNaN(num)) {
        onValueChange(num); // update parent
      }
    }
  };

  const handleBlur = () => {
    // On blur: if empty -> 0, else keep number
    const raw = localValue;
    const num = raw === "" ? 0 : Number(raw);
    const finalValue = Number.isFinite(num) ? num : 0;
    setLocalValue(String(finalValue)); // normalize in UI
    onValueChange(finalValue);         // ensure parent has final value (0 if empty)
  };

    const handleKeyDown = (e) => {
      const blocked = [
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "PageUp",
        "PageDown",
      ];
      if (blocked.includes(e.key)) e.stopPropagation();
      if (e.key === " ") e.stopPropagation();
    };

  return (
    <TextField
      fullWidth
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      type="text" 
      inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
        style: { padding: "2px 4px" },
      }}
      autoComplete="off"
    />
  );
};

export default IntegerEditCell;
